module.exports = __webpack_public_path__ + "static/media/NCA c. 1890.73276c22.jpg";